import { functionFrom, FunctionLibrary, getFunctionSignature } from '../FunctionDefinition';
import { TYPES } from '../Types';

// TODO add support for variadic functions with lazy params?
// until then, adding 2- and 3- and 4- and whatever-argument versions of these
// functions doesn't cost us much

const and2 = functionFrom(
  'and',
  [
    { name: 'a', type: TYPES.boolean, isLazy: true },
    { name: 'b', type: TYPES.boolean, isLazy: true },
  ] as const,
  TYPES.boolean,
  (_ctx, a, b) => a() && b(),
  'Logical AND; evaluates lazily and short-circuits after two operands.',
);

const and3 = functionFrom(
  'and',
  [
    { name: 'a', type: TYPES.boolean, isLazy: true },
    { name: 'b', type: TYPES.boolean, isLazy: true },
    { name: 'c', type: TYPES.boolean, isLazy: true },
  ] as const,
  TYPES.boolean,
  (_ctx, a, b, c) => a() && b() && c(),
  'Logical AND across three operands; lazy evaluation with short-circuit.',
);

const and4 = functionFrom(
  'and',
  [
    { name: 'a', type: TYPES.boolean, isLazy: true },
    { name: 'b', type: TYPES.boolean, isLazy: true },
    { name: 'c', type: TYPES.boolean, isLazy: true },
    { name: 'd', type: TYPES.boolean, isLazy: true },
  ] as const,
  TYPES.boolean,
  (_ctx, a, b, c, d) => a() && b() && c() && d(),
  'Logical AND across four operands; lazy evaluation with short-circuit.',
);

const or2 = functionFrom(
  'or',
  [
    { name: 'a', type: TYPES.boolean, isLazy: true },
    { name: 'b', type: TYPES.boolean, isLazy: true },
  ] as const,
  TYPES.boolean,
  (_ctx, a, b) => a() || b(),
  'Logical OR; evaluates lazily and short-circuits after two operands.',
);

const or3 = functionFrom(
  'or',
  [
    { name: 'a', type: TYPES.boolean, isLazy: true },
    { name: 'b', type: TYPES.boolean, isLazy: true },
    { name: 'c', type: TYPES.boolean, isLazy: true },
  ] as const,
  TYPES.boolean,
  (_ctx, a, b, c) => a() || b() || c(),
  'Logical OR across three operands; lazy evaluation with short-circuit.',
);

const or4 = functionFrom(
  'or',
  [
    { name: 'a', type: TYPES.boolean, isLazy: true },
    { name: 'b', type: TYPES.boolean, isLazy: true },
    { name: 'c', type: TYPES.boolean, isLazy: true },
    { name: 'd', type: TYPES.boolean, isLazy: true },
  ] as const,
  TYPES.boolean,
  (_ctx, a, b, c, d) => a() || b() || c() || d(),
  'Logical OR across four operands; lazy evaluation with short-circuit.',
);

const not = functionFrom(
  'not',
  [{ name: 'bool', type: TYPES.boolean }] as const,
  TYPES.boolean,
  (_ctx, a) => !a,
  'Logical NOT of a boolean value.',
);

export const BOOLEAN_FUNCTIONS = {
  [getFunctionSignature(and2)]: and2,
  [getFunctionSignature(and3)]: and3,
  [getFunctionSignature(and4)]: and4,
  [getFunctionSignature(or2)]: or2,
  [getFunctionSignature(or3)]: or3,
  [getFunctionSignature(or4)]: or4,
  [getFunctionSignature(not)]: not,
} satisfies FunctionLibrary;
